<template>
  <div class="floating-label-wrap" v-if="!loading">
    <input
      ref="input"
      :class="['floating-label-field floating-label-field--s3 ', className]"
      :value="value"
      :placeholder="placeholder"
      :id="id"
      :title="title"
      :pattern="pattern"
      :autocomplete="autocomplete"
      :required="required"
      :type="type ? type : 'text'"
    />
    <label :for="id" :class="['floating-label ', className]">
      {{ placeholder }}
    </label>
  </div>
  <Spinner v-else />
</template>

<script>
import Spinner from './../components/Spinner'

export default {
  name: 'Floating-Input',
  props: [
    'className',
    'loading',
    'value',
    'placeholder',
    'id',
    'title',
    'pattern',
    'autocomplete',
    'required',
    'type'
  ],
  data: function() {
    return {}
  },
  components: {
    Spinner: Spinner
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.floating-label-wrap {
  position: relative;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  border-radius: 5px;
  margin: 10px;
}
.floating-label-wrap label {
  color: rgba(108, 113, 113, 0.55);
}
/* Hide the browser-specific focus styles */
.floating-label-field {
  border-width: 1;

  color: #000;
  width: 100%;


  &:focus {
    outline: 0;
    box-shadow: 0;
  }

  &::placeholder {
    opacity: 0;
  }
}

.floating-label-field {
  &,
  & + .floating-label {
    line-height: 1;
    font-size: 14px;
    line-height: 1.6;
    padding: 10px;
  }
}

.floating-label-field {
  & + .floating-label {
    position: absolute;
    top: 0;
    left: 0;
    user-select: none;
  }
}

.floating-label-field {
  line-height: 1.6;
  border-bottom: 3px solid rgba(white, 0.05);
  background-color: transparent;
  color: #000;
  border: 0;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
}

.floating-label-field {
  & + .floating-label {
    transition: transform 0.25s, opacity 0.25s ease-in-out;
    transform-origin: 0 0;
  }
}

.floating-label-field {
  &:focus,
  &:not(:placeholder-shown) {
    border-color:$primary-color;
    padding: 17px 0 6px 10px;
    & + .floating-label {
      transform: translate(1%, -30%) scale(0.8);
      padding-bottom: 0px;
      font-size: 12px;
      color: #6c7171;
      top: 5px;
    }
  }
}

.floating-label-input {
  &:valid {
    &:not(:placeholder-shown) {
      border-color: rgba(#2ed573, 0.3);
    }
  }

  &:invalid {
    border-color: rgba(#ff4757, 0.3);
  }
}
</style>
